var modal = {
  sizes: {
    xSmall: {
      width: ['100%', '48%', '32%', '24%']
    },
    small: {
      width: ['100%', '60%', '42%', '36%']
    },
    regular: {
      width: ['100%', '84%', '60%', '48%']
    },
    large: {
      width: ['100%', '96%', '84%', '72%']
    }
  }
};
export default modal;